import React from 'react';
import { useIntl } from 'react-intl';

import { periods } from '../../config/config';
import { useRippleEffect } from '../../hooks/useRippleEffect';
import styles from './PeriodSelector.module.less';

interface PeriodSelectorProps {
  selectedPeriod: number;
  onPeriodChange: (period: number) => void;
}

const WAVE_DURATION = 2000;
const MAX_WAVES_PER_BUTTON = 3;

export const PeriodSelector: React.FC<PeriodSelectorProps> = ({
  selectedPeriod,
  onPeriodChange,
}) => {
  const intl = useIntl();
  const { ripples, createRipple } = useRippleEffect<number>(
    WAVE_DURATION,
    MAX_WAVES_PER_BUTTON
  );

  return (
    <div className={styles.periodSection}>
      <span className={styles.periodLabel}>
        {intl.formatMessage({ id: 'form.period.label' })}
      </span>
      <div className={styles.periodButtons}>
        {periods.map(period => (
          <button
            key={period}
            className={`${styles.periodButton} ${
              selectedPeriod === period ? styles.selected : ''
            }`}
            onClick={() => {
              createRipple(period);
              onPeriodChange(period);
            }}
            type="button"
          >
            <span className={styles.periodText}>
              {intl.formatMessage({ id: 'form.period.monthsShort' }, { period })}
            </span>
            {ripples
              .filter(r => r.identifier === period)
              .map(ripple => (
                <span key={ripple.id} className={styles.wave} />
              ))}
          </button>
        ))}
      </div>
    </div>
  );
};
